import { createFileRoute } from '@tanstack/react-router'
import type { ReactElement } from 'react'
import { PublicShortlistPage } from '~/domains/shortlists/components/PublicShortlistPage'

const ShortlistRoute = (): ReactElement => {
  const { instance, token } = Route.useParams()

  return <PublicShortlistPage instance={instance} token={token} />
}

export const Route = createFileRoute('/shortlist/$instance/$token')({
  component: ShortlistRoute
})
